exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-rtrvl-tsx": () => import("./../../../src/templates/rtrvl.tsx" /* webpackChunkName: "component---src-templates-rtrvl-tsx" */)
}

